import { Outlet } from 'react-router-dom';
import { SearchProvider } from '~/components/searchTable/searchControlBar/SearchContext';

export default function ProductsLayout() {
  return (
    <SearchProvider entity="Product">
      <Outlet />
    </SearchProvider>
  );
}
